// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__il0aU","modal":"Modal_modal__7Omag","modalHeader":"Modal_modalHeader__jWWh-","modalBody":"Modal_modalBody__kbeNa"};